export default __webpack_public_path__ + "static/media/no_user.86033422.jpg";